import { Divider, Paper } from "@material-ui/core";
import ReceiptIcon from "@material-ui/icons/Receipt";

import "./GridCard.css";
import { ILegScanProps } from "../../../../../../../@types/components/legScanDetailsprops.types";
import ScanHeaderInfo from "../scanDetailsSections/ScanHeaderInfo";
import ScanSnapshot from "../scanDetailsSections/ScanSnapshot";
import ScanAngles from "../scanDetailsSections/ScanAngles";
import ScanLengthWidthArchTables from "../scanDetailsSections/ScanLengthWidthArchTables";
import ScanAdditionalMeasurements from "../scanDetailsSections/ScanAdditionalMeasurements";
import ScanLandmarkCoordinates from "../scanDetailsSections/ScanLandmarkCoordinates";
import ScanFiles from "../scanDetailsSections/ScanFiles";
import HealthReportButton from "../scanDetailsSections/HealthReportButton";

const GridCard = ({ legScan, state }: ILegScanProps) => {
	return (
		<Paper elevation={3} style={{ height: "100%", padding: "1.5rem", backgroundColor: "#F8F8FF" }}>
			<h2 className="Profile-info-text">
				<span>
					<ReceiptIcon style={{ fontSize: "1.6rem" }} />
				</span>
				Scan Details
			</h2>

			<ScanHeaderInfo legScan={legScan} state={state} />
			<Divider style={{ margin: "1rem 0" }} />

			<ScanSnapshot legScan={legScan} state={state} />
			<Divider style={{ margin: "1.5rem 0" }} />

			<ScanAngles legScan={legScan} state={state} />
			<Divider style={{ margin: "1.5rem 0" }} />

			<ScanLengthWidthArchTables legScan={legScan} state={state} />
			<Divider style={{ margin: "1.5rem 0" }} />

			<ScanAdditionalMeasurements legScan={legScan} state={state} />

			<div style={{ marginTop: "1.5rem" }}>
				<ScanLandmarkCoordinates legScan={legScan} state={state} />
			</div>

			<div
				style={{ marginTop: "1.5rem", display: "flex", alignItems: "center", gap: "1.5rem", flexWrap: "wrap" }}
			>
				<HealthReportButton legScan={legScan} state={state} />
				<ScanFiles legScan={legScan} state={state} />
			</div>
		</Paper>
	);
};

export default GridCard;
